import React from 'react';
import I1 from  '../../assets/face.png'
import I2 from  '../../assets/what.png'
import I3 from  '../../assets/insta.png'
import I4 from  '../../assets/tik.png'

const Icons = ({ name,  color = 'currentColor' }) => {
    const icon = {
     face: I1,
      what:  I2,
      insta: I3,
      tik: I4,
    };
    const IconComponent = icon[name];

  return (
    
     <img
          src={IconComponent}
          alt={name}
          width='3%'
          style={{
            fill: color,
            stroke: color,
            marginRight: '20px'
          }}
        />
     
     
    
 
  );
};

export default Icons;